import Effect from './Effect';
export default Effect;
